export default __webpack_public_path__ + "static/media/tweet_right.9739da76.png";